import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import AwesomeSlider from "react-awesome-slider";
import AwesomeSliderStyles from "../scss/light-slider.scss";
import AwesomeSliderStyles2 from "../scss/dark-slider.scss";

class ProjectDetailsModal extends Component {
  render() {
    const { data } = this.props;

    if (!data) return null; // Si aucune donnée n'est passée, ne rien afficher.

    const { title, description, url, technologies = [], images = [] } = data;

    const techList = technologies.map((icons, i) => (
        <li className="list-inline-item mx-3" key={i}>
        <span>
          <div className="text-center">
            <i className={icons.class} style={{ fontSize: "300%" }}>
              <p className="text-center" style={{ fontSize: "30%" }}>
                {icons.name}
              </p>
            </i>
          </div>
        </span>
        </li>
    ));

    const imageSlides = images.map((elem, i) => <div key={i} data-src={elem} />);

    return (
        <Modal
            {...this.props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-inside"
        >
        <span onClick={this.props.onHide} className="modal-close">
          <i className="fas fa-times fa-3x close-icon"></i>
        </span>
          <div className="col-md-12">
            <div className="col-md-10 mx-auto" style={{ paddingBottom: "50px" }}>
              <AwesomeSlider
                  cssModule={[AwesomeSliderStyles, AwesomeSliderStyles2]}
                  animation="scaleOutAnimation"
                  className="slider-image"
              >
                {imageSlides}
              </AwesomeSlider>
            </div>
            <div className="col-md-10 mx-auto">
              <h3 style={{ padding: "5px 5px 0 5px" }}>
                {title}
                {url ? (
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-href"
                >
                  <i
                    className="fas fa-external-link-alt"
                    style={{ marginLeft: "10px" }}
                  ></i>
                </a>
              ) : null}
              </h3>
              <p className="modal-description">{description}</p>
              <div className="col-md-12 text-center">
                <ul className="list-inline mx-auto">{techList}</ul>
              </div>
            </div>
          </div>
        </Modal>
    );
  }
}

export default ProjectDetailsModal;
